import { render } from "./VendorPerformance.vue?vue&type=template&id=5f61d3bf&scoped=true"
import script from "./VendorPerformance.vue?vue&type=script&lang=js"
export * from "./VendorPerformance.vue?vue&type=script&lang=js"

import "./VendorPerformance.vue?vue&type=style&index=0&id=5f61d3bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f61d3bf"]])

export default __exports__